/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  auth: {
    clientId: "f2ab5947-9c58-4d71-baf0-78547ca452a4",
    authority: "https://login.microsoftonline.com/c05b8d5a-b883-4afb-ae93-db5db239911c",
    redirectUri: "https://localhost:44358",
    postLogoutRedirectUri: "https://localhost:44358",
    navigateToLoginRequestUrl: true,
    validateAuthority: true,
    scopes: ["openid", "profile", "email", "offline_access"]
  }
};
